import { useEffect, useState } from "react";
import { DownloadManager } from "src/utils/downloadManager";

export function useDownload(key, config = {}, { autoStart = true, startWhen } = {}) {
  const [state, setState] = useState(() => (key ? DownloadManager.snapshot(key) : {}));

  useEffect(() => {
    if (!key) return;
    const unsub = DownloadManager.subscribe(key, setState);
    return () => unsub();
  }, [key]);

  const ready = typeof startWhen === "function" ? !!startWhen() : true;

  useEffect(() => {
    if (!key || !autoStart || !config || !ready) return;
    DownloadManager.start(key, config);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, autoStart, ready]);

  return state;
}
